module.exports = __webpack_public_path__ + "img/point-2.1aefe9a6.png";